import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { Students, StudentsDetails, UpdateStudents, CreateStudent } from "../../models/StudentsModel/students.model";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { generatePath } from "react-router-dom";

export default class StudentService {
  static fetchStudents(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    _axiosInstance
      .get(ApiRoutes.SELF_REGISTERED_STUDENTS_LIST, { params })
      .then((response) => {
        const students = deserialize(Students, response?.data["students"]);
        const meta = deserialize(PaginationModel, response?.data["meta"]);
        onSuccess(students, meta);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching students",
          description: "Please proceed with valid data!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static getStudentsDetails(
    studentId: number,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(generatePath(ApiRoutes.INSTITUTE_STUDENT__DETAILS, { studentId }))
      .then((response) => {
        const students = deserialize(StudentsDetails, response?.data["student"]);
        onSuccess(students);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching student details",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static createStudents(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .post(ApiRoutes.STUDENTS_LIST, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating students",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }
  static createStudent(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .post(ApiRoutes.STUDENTS_LIST, {student: serialize(CreateStudent, data)})
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating students",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }

  static createPrivateStudent(
    data: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .post(ApiRoutes.PRIVATE_STUDENTS, {student: serialize(CreateStudent, data)})
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating students",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }

  static updateStudent(
    studentId: number,
    data: UpdateStudents,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = { student: serialize(UpdateStudents, data) };
    axiosInstance
      .put(generatePath(ApiRoutes.SINGLE_STUDENT, { studentId }), payload)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in updating student",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }

  static updatePrivateStudent(
    studentId: number,
    data: UpdateStudents,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = { student: serialize(UpdateStudents, data) };
    axiosInstance
      .put(generatePath(ApiRoutes.PRIVATE_SINGLE_STUDENT, { studentId }), payload)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in updating student",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError(error?.response?.data);
      })
      .finally(() => {
        onFinal();
      });
  }
}
